import { useMemo } from 'react';

export function useSplitQuotesByStatus(quotes) {
  const activeQuotes = useMemo(
    () => {
      const active = quotes?.filter((quote) => {
        return quote.status?.toLowerCase() === 'active';
      });
      return active;
    },
    [quotes]
  );

  const expiredQuotes = useMemo(
    () => {
      const expired = quotes.filter((quote) => quote.status?.toLowerCase() === 'expired');
      return expired;
    },
    [quotes]
  );

  return { activeQuotes, expiredQuotes };
}